"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _BookInfoSelectors = require("MeetingsLib/selectors/BookInfoSelectors");

var _color = require("MeetingsLib/utils/color");

var _color2 = require("MeetingsBase/utils/color");

var _dates = require("MeetingsBase/utils/dates");

var _enums = require("MeetingsLib/constants/enums");

var _paths = require("MeetingsLib/constants/paths");

var DatePickerButton = (0, _createReactClass.default)({
  displayName: "DatePickerButton",
  propTypes: {
    availableDates: _propTypes.default.instanceOf(_immutable.Seq).isRequired,
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired,
    currentTime: _propTypes.default.number.isRequired,
    date: _propTypes.default.string.isRequired,
    daysToAdd: _propTypes.default.number.isRequired,
    handleSetEventDate: _propTypes.default.func.isRequired,
    selected: _propTypes.default.bool,
    // troubleshoot mode
    bookableDates: _propTypes.default.instanceOf(_immutable.List),
    configuredAvailabilityByDate: _propTypes.default.instanceOf(_immutable.OrderedMap),
    editLinkURL: _propTypes.default.string.isRequired,
    troubleshootTimesForSelectedDurationByDay: _propTypes.default.instanceOf(_immutable.Map),
    minimumNoticeTimeBusyDays: _propTypes.default.instanceOf(_immutable.List),
    isTroubleshooting: _propTypes.default.bool,
    userTimezone: _propTypes.default.string.isRequired
  },
  isValid: function isValid() {
    var _this$props = this.props,
        availableDates = _this$props.availableDates,
        date = _this$props.date;
    return availableDates.includes(date);
  },
  getClassNames: function getClassNames() {
    var selected = this.props.selected;
    var valid = this.isValid();
    return (0, _classnames.default)('date-picker-btn pointer m-all-1', valid ? "valid" : "disabled", selected && "selected");
  },
  getAdvancedSettingsTabURL: function getAdvancedSettingsTabURL() {
    var editLinkURL = this.props.editLinkURL;
    return editLinkURL + "/" + _paths.AVAILABILITY_TAB;
  },
  shouldTroubleshoot: function shouldTroubleshoot() {
    var _this$props2 = this.props,
        date = _this$props2.date,
        availableDates = _this$props2.availableDates,
        isTroubleshooting = _this$props2.isTroubleshooting;

    if (!isTroubleshooting) {
      return false;
    }

    var dayHasAvailability = availableDates.includes(date);
    return !dayHasAvailability;
  },
  getUnbookableReason: function getUnbookableReason() {
    var _this$props3 = this.props,
        bookableDates = _this$props3.bookableDates,
        configuredAvailabilityByDate = _this$props3.configuredAvailabilityByDate,
        currentTime = _this$props3.currentTime,
        date = _this$props3.date,
        troubleshootTimesForSelectedDurationByDay = _this$props3.troubleshootTimesForSelectedDurationByDay,
        minimumNoticeTimeBusyDays = _this$props3.minimumNoticeTimeBusyDays,
        userTimezone = _this$props3.userTimezone;

    if (!this.shouldTroubleshoot()) {
      return null;
    }

    if ((0, _dates.isDateInPast)(date, currentTime, userTimezone)) {
      return _enums.UNAVAILABLE_REASONS.PAST;
    }

    if (!bookableDates.includes(date)) {
      return _enums.UNAVAILABLE_REASONS.DATE_NOT_CONFIGURED;
    }

    if (!configuredAvailabilityByDate.get(date)) {
      return _enums.UNAVAILABLE_REASONS.TIME_NOT_CONFIGURED;
    }

    if (minimumNoticeTimeBusyDays.includes(date)) {
      return _enums.UNAVAILABLE_REASONS.MINIMUM_NOTICE;
    }

    var troubleshootTimesForDate = troubleshootTimesForSelectedDurationByDay.get(date);
    var overlapsWithDayLongEvent = troubleshootTimesForDate && troubleshootTimesForDate.find(function (troubleshotTime) {
      return troubleshotTime.reason === _enums.UNAVAILABLE_REASONS.ALL_DAY_EVENT;
    });

    if (overlapsWithDayLongEvent) {
      return _enums.UNAVAILABLE_REASONS.ALL_DAY_EVENT;
    }

    return null;
  },
  getStyle: function getStyle() {
    var _this$props4 = this.props,
        selected = _this$props4.selected,
        primaryColor = _this$props4.branding.primaryColor;
    var primaryTextColor = (0, _color2.getTextColor)(primaryColor);

    if (selected) {
      return {
        color: primaryColor,
        background: primaryTextColor
      };
    }

    if (this.shouldTroubleshoot() && this.getUnbookableReason()) {
      var shadedColor = (0, _color.shadeColor)(primaryColor, 40);
      return {
        color: (0, _color2.getTextColor)(shadedColor),
        background: shadedColor
      };
    }

    return {
      color: primaryTextColor
    };
  },
  getTooltipText: function getTooltipText() {
    var editLinkURL = this.props.editLinkURL;
    var unbookableReason = this.getUnbookableReason();

    switch (unbookableReason) {
      case _enums.UNAVAILABLE_REASONS.PAST:
        return _react.default.createElement(_FormattedMessage.default, {
          message: "troubleshoot.day.past"
        });

      case _enums.UNAVAILABLE_REASONS.DATE_NOT_CONFIGURED:
        return _react.default.createElement(_FormattedJSXMessage.default, {
          message: "troubleshoot.day.customRange_jsx",
          options: {
            href: this.getAdvancedSettingsTabURL(),
            external: true
          },
          elements: {
            Link: _UILink.default
          }
        });

      case _enums.UNAVAILABLE_REASONS.TIME_NOT_CONFIGURED:
        return _react.default.createElement(_FormattedJSXMessage.default, {
          message: "troubleshoot.day.unset_jsx",
          options: {
            href: editLinkURL + "/" + _paths.AVAILABILITY_TAB,
            external: true
          },
          elements: {
            Link: _UILink.default
          }
        });

      case _enums.UNAVAILABLE_REASONS.MINIMUM_NOTICE:
        return _react.default.createElement(_FormattedJSXMessage.default, {
          message: "troubleshoot.day.minimum_jsx",
          options: {
            href: this.getAdvancedSettingsTabURL(),
            external: true
          },
          elements: {
            Link: _UILink.default
          }
        });

      case _enums.UNAVAILABLE_REASONS.ALL_DAY_EVENT:
        return _react.default.createElement(_FormattedMessage.default, {
          message: "troubleshoot.day.dayLong"
        });

      default:
        return null;
    }
  },
  renderCalendarDate: function renderCalendarDate() {
    var date = this.props.date;
    return _react.default.createElement(_UIFlex.default, {
      align: "center",
      justify: "center",
      className: "calendar-date"
    }, _I18n.default.moment(date).format('D'));
  },
  render: function render() {
    var _this$props5 = this.props,
        date = _this$props5.date,
        daysToAdd = _this$props5.daysToAdd,
        handleSetEventDate = _this$props5.handleSetEventDate;
    var placement = daysToAdd > 3 ? 'top left' : 'top right';
    var tabIndex = this.isValid() ? 0 : null;

    var button = _react.default.createElement(_UIBox.default, {
      grow: 1,
      shrink: 1,
      basis: "100%",
      style: this.getStyle(),
      onClick: function onClick() {
        return handleSetEventDate(date);
      },
      onKeyPress: function onKeyPress(e) {
        return e.key === 'Enter' && handleSetEventDate(date);
      },
      className: this.getClassNames(),
      tabIndex: tabIndex
    }, this.renderCalendarDate());

    if (!this.props.isTroubleshooting) {
      return button;
    }

    var tooltipText = this.getTooltipText();
    return _react.default.createElement(_UITooltip.default, {
      disabled: !tooltipText,
      maxWidth: 210,
      placement: placement,
      title: tooltipText,
      use: "longform"
    }, button);
  }
});

var _default = (0, _reactRedux.connect)(function (state, props) {
  return {
    selected: (0, _BookInfoSelectors.getEvent)(state).dateString === props.date
  };
})(DatePickerButton);

exports.default = _default;
module.exports = exports.default;